import React, { useEffect, useState, useContext, useRef, useMemo, Fragment } from "react";
import { AiOutlineSearch, AiOutlineCloseCircle } from "react-icons/ai";
import dayjs from "dayjs";
import Link from "next/link";
import Head from "next/head";
import Image from "next/image";
import { Table, Button, Col, Form, InputGroup, Row, Card } from "react-bootstrap";
import { TableHeader } from "../../../../components/table/TableHeader";
import SQBestBetsSreenshot from "../../../../assets/images/SQBestBetsSreenshot.png";
import { appServerSideProps } from "../../../../utils/getAppService";
import Input from "../../../../components/form/Input";
import Utils from "../../../../utils/Utils";
import { authGetRequest } from "../../../../utils/authGetRequest";
import { AppContext } from "../../../../context/state";
import MainLayout from "../../../../components/MainLayout/MainLayout";
import Accordion from "../../../../components/accordion/Accordion";
import transformDate from "../../linevalue-welcome/utils/transformDate";
import transformTime from "../../linevalue-welcome/utils/transformTime";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useRouter } from "next/router";
import NotFound from "../../../../components/404/NotFound";
import WinningMetrics from "../../../../components/WinningMetrics";
import { getDefYear } from "../../../../constants/main";
import { SIGNUPS_CLOSED_MESSAGE } from "../../../../constants/main";
const accordionData = [
  {
    "@type": "Question",
    name: "How to select a props pick",
    content: (
      <>
        <p style={{ fontWeight: 600, color: "black" }}>
          1. All plays shown on the props page are recommended bets. Recommended bets are bets with a ShotQuality Edge.
          The Edge is how confident the model is in it’s projection.
        </p>

        <p style={{ fontWeight: 600, color: "black", marginTop: "15px" }}>
          2. The Best Bet is the best sportsbook for the Props Pick.
        </p>
      </>
    ),
    id: "accordionData1",
  },
  {
    "@type": "Question",
    name: "How to evaluate a prop",
    content: (
      <>
        <p style={{ fontWeight: 600, color: "black" }}>1. Click on any Props Pick to see the player details</p>

        <p style={{ fontWeight: 600, color: "black", marginTop: "15px" }}>
          2. Use the ShotQuality Scores vs actual scores past performance to evaluate the chance of the Props Pick
          performing.
        </p>
      </>
    ),
    id: "accordionData2",
  },
];

const miscTableHeader = [
  {
    title: "Date",
    showImage: false,
    sortable: true,
    key: "date",
  },
  {
    title: "Player",
    showImage: false,
    sortable: true,
    key: "Player",
  },
  {
    title: "Opponent",
    showImage: false,
    sortable: true,
    key: "Opponent",
  },

  {
    title: "Avg Pts Per Game",
    showImage: false,
    sortable: true,
    key: "Points",
    classList: ["shrink-column"],
  },

  {
    title: "Avg SQ Points Scored Per Game",
    showImage: false,
    sortable: true,
    key: "SQ Points",
    classList: ["shrink-column"],
  },
  {
    title: "Difference",
    showImage: false,
    sortable: true,
    key: "Diff",
  },
  {
    title: "Consensus Line",
    showImage: false,
    sortable: true,
    key: "Consensus",
  },
  {
    title: "Avg Minutes Per Game",
    showImage: false,
    sortable: true,
    key: "Minutes",
    classList: ["shrink-column"],
  },

  // {
  //   title: "Matchup Difficulty",
  //   showImage: true,
  //   sortable: false,
  //   key: "FanDuel",
  // },

  // {
  //   title: "Projected Defensive Matchup",
  //   showImage: false,
  //   sortable: false,
  //   key: "Projected Defensive Matchup",
  // },
  // {
  //   title: "Matchup Insight",
  //   showImage: false,
  //   sortable: false,
  //   key: "Matchup Insight",
  // },
];

const dynamicsort = (property, order, picksType, sortWithDateAndDiff) => {
  var sort_order = 1;
  if (order === "desc") {
    sort_order = -1;
  }
  if (sortWithDateAndDiff || property === "date") {
    property = "Diff";
    return function (a, b) {
      if (dayjs(a["date"], "YYYY-MM-DD").isBefore(dayjs(b["date"], "YYYY-MM-DD"))) {
        return 1 * sort_order;
      } else if (dayjs(a["date"], "YYYY-MM-DD").isAfter(dayjs(b["date"], "YYYY-MM-DD"))) {
        return -1 * sort_order;
      } else {
        if (a[picksType][property] < b[picksType][property]) {
          return 1;
        } else if (a[picksType][property] > b[picksType][property]) {
          return -1;
        } else {
          return 0;
        }
      }
    };
  }

  return function (a, b) {
    if (a[picksType][property] < b[picksType][property]) {
      return -1 * sort_order;
      // a should come after b in the sorted order
    } else if (a[picksType][property] > b[picksType][property]) {
      return 1 * sort_order;
      // a and b are the same
    } else {
      return 0 * sort_order;
    }
  };
};

const PlayerPropsPage = ({ user }) => {
  const router = useRouter();
  let leagueName = router.query?.league;
  let leagueFromUrl = leagueName === "ncaa" ? "college_mens" : leagueName === "ncaaw" ? "college_womens" : leagueName;
  const year = getDefYear(leagueName);
  const { store, setStore } = useContext(AppContext);
  const [picksType, setPicksType] = useState("Last10");
  const searchInputRef = useRef(null);
  const [displaySearchResults, setDisplaySearchResults] = useState(false);
  const [searchAutocomplete, setSearchAutocomplete] = useState({
    team: [],
    player: [],
  });
  const [authToken, setAuthToken] = useState(null);
  const [searchKey, setSearchKey] = useState("");

  const [gamelogs, setGamelogs] = useState([]);
  const [filteredGameLogs, setFilteredGameLogs] = useState([]);

  const isTrader = Utils.isTrader(user);

  useEffect(() => {
    setStore({ ...store, leagueType: leagueFromUrl ? leagueFromUrl : store.leagueType });
  }, [leagueFromUrl]);

  useEffect(() => {
    setAuthToken(document.cookie.split("token_access").pop().split(";").shift().split("=").pop());
  }, []);

  useEffect(() => {
    if (authToken) {
      // authGetRequest(`/api/nba/value-finder-player-props`, authToken)
      //   .then((response) => response.data)
      //   .then((response) => {
      //     setTeamData(response.data);
      //   })
      //   .catch((err) => {
      //     console.error("error==>>", err);
      //   });

      authGetRequest(`/api/${leagueFromUrl}/player_gamelogs`, authToken)
        .then((response) => response.data)
        .then((data) => {
          setGamelogs(data.data);
          // setFilteredGameLogs(data.data);
          setAscOrder(true);
          sort("Diff", data.data, true);
        })
        .catch((err) => {
          console.error("error==>>", err);
        });
    }
  }, [authToken]);

  const isStandardPlan = Utils.hasStandardPlan(user) || Utils.hasTrial(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isPaidPlan = (isStandardPlan || isPremiumPlan) && user?.has_paid;

  const searchByPlayer = (searchTerm) => {
    const filteredPlayer = gamelogs.filter((player) => player.Player.toLowerCase().includes(searchTerm.toLowerCase()));
    return filteredPlayer;
  };
  const searchByTeam = (searchTerm) => {
    const filteredTeam = gamelogs.filter((player) => player["Team"].toLowerCase().includes(searchTerm.toLowerCase()));
    let teamNames = [];
    let uniqueTeamsObj = [];
    filteredTeam.forEach((team) => {
      if (!teamNames.includes(team["Team"])) {
        teamNames.push(team["Team"]);
        uniqueTeamsObj.push(team);
      }
    });
    return uniqueTeamsObj;
  };

  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setSearchKey(e.target.value);
      setDisplaySearchResults(true);
    }

    if (e.target.value === "") {
      clearSearch();
    }
  };

  const searchData = (searchTerm, searchType) => {
    let filteredList = [];
    if (searchType === "player") {
      filteredList = gamelogs.filter((player) => player.Player.toLowerCase().includes(searchTerm.toLowerCase()));
    } else if (searchType === "team") {
      filteredList = gamelogs.filter((player) => player["Team"] === searchTerm);
    }
    return filteredList;
  };

  const displaySearchData = (e, searchType) => {
    searchInputRef.current.value = e.target.innerText;
    setSearchKey(e.target.innerText);
    setFilteredGameLogs(searchData(e.target.innerText, searchType));
    setDisplaySearchResults(false);
  };

  const clearSearch = (e) => {
    setSearchKey("");
    setFilteredGameLogs(gamelogs);
    searchInputRef.current.value = "";
    setDisplaySearchResults(false);
  };

  useEffect(() => {
    searchKey &&
      setSearchAutocomplete({
        player: searchByPlayer(searchKey.toLowerCase()).splice(0, 7),
        team: searchByTeam(searchKey.toLowerCase()).splice(0, 7),
      });
  }, [searchKey, setSearchKey]);

  const handlePicksTypeChange = (e) => {
    setPicksType(e.target.value);
  };
  useEffect(() => {
    sort("Diff", null, true);
  }, [picksType]);
  const LEAGUE_NAME = leagueFromUrl === "college_mens" ? "NCAA Men's" : leagueFromUrl?.toUpperCase();

  const [sortedKey, setSortedKey] = useState("Diff");
  const [ascOrder, setAscOrder] = useState(false);

  const sort = (key, data = null, sortWithDateAndDiff) => {
    let res = [];
    let rawData = data ? [...data] : [...filteredGameLogs];
    let replaceKey;
    const headerObj = miscTableHeader.filter((column) => column["key"] === key)[0];
    replaceKey = headerObj["key"];
    let keySumm = {};

    if (key === "Projected (Home)" && columnType == "defen") {
      replaceKey = "summaryColumns";
      keySumm["key1"] = "Projected Home Score";
      keySumm["key2"] = "Projected Away Score";
    }
    if (key === "Player" || key === "Consensus") {
      if (sortedKey === key) {
        let order = ascOrder ? "asc" : "desc";
        res = rawData.sort(Utils.dynamicsort(replaceKey, order, keySumm));
        setAscOrder(!ascOrder);
      } else {
        setAscOrder(false);
        setSortedKey(key);
        res = rawData.sort(Utils.dynamicsort(replaceKey, null, keySumm));
      }
    } else {
      if (sortedKey === key) {
        let order = ascOrder ? "asc" : "desc";
        order = sortWithDateAndDiff ? "desc" : order;
        res = rawData.sort(dynamicsort(replaceKey, order, picksType, sortWithDateAndDiff));
        setAscOrder(!ascOrder);
      } else {
        setAscOrder(false);
        setSortedKey(key);
        res = rawData.sort(dynamicsort(replaceKey, null, picksType, sortWithDateAndDiff));
      }
    }
    setFilteredGameLogs([...res]);
  };

  const getPlayerScoreEmoji = (diff, points) => {
    if (!points || +points === 0) return "😑";
    const scoreDifference = diff;
    return scoreDifference < -6
      ? "🥶🥶"
      : scoreDifference >= -6 && scoreDifference < -2
      ? "🥶"
      : scoreDifference >= -2 && scoreDifference <= 2
      ? "🎯"
      : scoreDifference > 2 && scoreDifference <= 6
      ? "🔥"
      : "🔥🔥";
  };

  return (
    <>
      <Head>
        <title>{`${year} ${leagueName?.toUpperCase()} Basketball Player Props Research | ShotQuality Bets`}</title>
        <meta
          name="description"
          content={`ShotQuality Bets provides the most accurate, robust and predictable data for ${leagueName?.toUpperCase()}. Access our data now to unlock unique ${leagueName?.toUpperCase()} shot type and player location data.`}
        />
      </Head>
      <MainLayout>
        {leagueFromUrl ? (
          <main id="ContentBox playerprops-mobile-view" style={{ minHeight: "100vh" }}>
            <div className="MiscStats Value-Finder pt-5">
              <section className="header-primary" style={{ marginBottom: 0, paddingBottom: 0 }}>
                <div className="container-fluid">
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "space-between",
                      flexDirection: "column",
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    <Col
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      {leagueFromUrl && (
                        <>
                          <Col
                            className={"box Value-Finder-title-mobile-hide"}
                            style={{ display: "flex", marginBottom: "0" }}
                          >
                            <div className="box Value-Finder-title-mobile-hide">
                              <h2>{LEAGUE_NAME} Player Props Research</h2>
                              <p>Picks and predictions for {LEAGUE_NAME} basketball player props.</p>
                            </div>
                          </Col>
                        </>
                      )}
                    </Col>

                    <div className="box Value-Finder-title-mobile">
                      {leagueFromUrl && <h2>{LEAGUE_NAME} Basketball</h2>}
                    </div>
                    {user && (
                      <Col className="Value-Finder-title-mobile">
                        <Input
                          icon={<AiOutlineSearch />}
                          placeholder="Search for a Player or Team"
                          className="form-control w-100 search-input Value-Finder-title-mobile"
                          ref={searchInputRef}
                          onInput={handleInputChange}
                          rightIcon={
                            searchInputRef?.current?.value.length > 0 ? (
                              <AiOutlineCloseCircle onClick={clearSearch} />
                            ) : null
                          }
                        />

                        {displaySearchResults && (
                          <div className="search-results">
                            <h6 className="text-left-2">Players</h6>
                            {searchAutocomplete["player"].length > 0 ? (
                              searchAutocomplete["player"].map((searchTerm, i) => (
                                <span
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "player")}
                                  key={`searchPlayer${i + 1}`}
                                >
                                  {searchTerm.Player}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}
                            <h6 className="text-left-2">Teams</h6>
                            {searchAutocomplete["team"].length > 0 ? (
                              searchAutocomplete["team"].map((searchTerm, i) => (
                                <span
                                  key={searchTerm + i}
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "team")}
                                >
                                  {searchTerm.Team}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}
                          </div>
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
              </section>

              {leagueFromUrl === "college_mens" ? (
                <></>
              ) : user ? (
                <section className="header-secondary" style={{ marginTop: 0, paddingTop: 0 }}>
                  <div className="container-fluid">
                    <div className="d-flex pl-3" style={{ gap: "1rem" }}>
                      <div className="text-center switch-container">
                        <div style={{ background: "#0F131B", borderRadius: "10px" }} className="btn-group w-90">
                          {[
                            // "Season",
                            "Last5",
                            "Last10",
                            "Last20",
                          ].map((type) => (
                            <button
                              key={type}
                              type="button"
                              className={`btn btn-lg btn-primary value-finder-buttons-group ${
                                picksType === type ? "active" : ""
                              }`}
                              value={type}
                              onClick={(e) => {
                                handlePicksTypeChange(e);
                              }}
                            >
                              {type}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="Value-Finder-title-mobile-hide" style={{ maxWidth: "450px", minWidth: "256px" }}>
                        <Input
                          icon={<AiOutlineSearch />}
                          placeholder="Search for a Player or Team"
                          className="form-control w-100 search-input show-desktop"
                          ref={searchInputRef}
                          onInput={handleInputChange}
                          rightIcon={
                            searchInputRef?.current?.value.length > 0 ? (
                              <AiOutlineCloseCircle onClick={clearSearch} />
                            ) : null
                          }
                        />
                        {displaySearchResults && (
                          <div className="search-results">
                            <h6 className="text-left-2">Players</h6>
                            {searchAutocomplete["player"].length > 0 ? (
                              searchAutocomplete["player"].map((searchTerm, i) => (
                                <span
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "player")}
                                  key={`searchPlayer${i + 1}`}
                                >
                                  {searchTerm.Player}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}
                            <h6 className="text-left-2">Teams</h6>
                            {searchAutocomplete["team"].length > 0 ? (
                              searchAutocomplete["team"].map((searchTerm, i) => (
                                <span
                                  key={searchTerm + i}
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "team")}
                                >
                                  {searchTerm.Team}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                <></>
              )}

              <section className="page-content Picks PlayerProps">
                <div className="container-fluid">
                  <>
                    {!isPaidPlan ? (
                      <div className="col-md-12 dummyLockWrapper">
                        <div style={{ filter: "blur 8px" }} className="imgWrapper">
                          <img src={SQBestBetsSreenshot.src} className="bracketBackground" alt="SQBestBets" />
                        </div>

                        <Col
                          className="dummyLock"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            position: "absolute",
                            top: "20px",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        >
                          <h3>Want to see more?</h3>
                          <p>
                            {/* Unlock ShotQuality Best Bets. To see all data on this page, please enter your email to get access. */}
                            {SIGNUPS_CLOSED_MESSAGE}
                          </p>
                          <div className="requestEmailWrapper">
                            <Row className="mm-email-wrapper">
                              <Form className="mm-form">
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                  <InputGroup className="mb-3 mm-input-main-wrapper">
                                    {user ? null : (
                                      <Button
                                        className={`mm-access-button mx-auto`}
                                        style={{
                                          backgroundColor: "#f26b0b",
                                          color: "white",
                                          padding: "10px 30px",
                                          border: "none",
                                        }}
                                        onClick={() => router.push("/login")}
                                      >
                                        Sign In
                                      </Button>
                                    )}
                                  </InputGroup>
                                </Form.Group>
                              </Form>
                            </Row>
                          </div>
                        </Col>
                      </div>
                    ) : gamelogs.length > 0 ? (
                      <div>
                        {/* Table for desktop view */}
                        <div className="d-none d-md-block">
                          <Table responsive striped bordered hover>
                            <thead>
                              <tr>
                                <TableHeader
                                  headers={
                                    isTrader
                                      ? miscTableHeader.filter((item) => item.key !== "Consensus")
                                      : miscTableHeader
                                  }
                                  onSortClick={sort}
                                  ascOrder={ascOrder}
                                  sortedKey={sortedKey}
                                />
                              </tr>
                            </thead>
                            <tbody>
                              {filteredGameLogs.map((player, rowIndex) => (
                                <Fragment key={rowIndex}>
                                  <tr key={rowIndex}>
                                    <td key={"date"} className={"text-left pt-3"}>
                                      <Link
                                        href={`/${leagueName}/matchup-output/${player["Team"]}/${player["Opponent"]}/true`}
                                        target="_blank"
                                      >
                                        {player["date"]}
                                      </Link>
                                    </td>
                                    <td key={"PlayerName"} className={"text-center"}>
                                      <strong>
                                        <Link
                                          href={`/${leagueName}/player-props/${player["Team"]}/${player.Player}`}
                                          target="_blank"
                                        >
                                          {player.Player}
                                        </Link>
                                      </strong>
                                      <Link href={`/team/${leagueName}/${year}/${player["Team"]}`} target="_blank">
                                        <small>{player["Team"]}</small>
                                      </Link>
                                    </td>
                                    <td key={"Opponent"} className={"text-center"}>
                                      <Link
                                        href={`/${leagueName}/matchup-output/${player["Team"]}/${player["Opponent"]}/true`}
                                        target="_blank"
                                      >
                                        <Image
                                          src={`/static/media/logos/${player["Opponent"]}.png`}
                                          alt={player["Opponent"]}
                                          width={28}
                                          height={28}
                                        />{" "}
                                        {player["Opponent"]}
                                      </Link>
                                      {/* <div>(O/U)</div> */}
                                    </td>

                                    <td key={"Points"} className={"text-center"}>
                                      {player[picksType]["Points"]}
                                    </td>
                                    <td key={"SQ Points"} className={"text-center"}>
                                      {player[picksType]["SQ Points"]}
                                    </td>
                                    <td key={"Diff"} className="text-nowrap text-center">
                                      {`${Math.abs(player[picksType]["Diff"])} `}
                                      <span className="d-inline-block text-left" style={{ minWidth: "2.8rem" }}>
                                        {getPlayerScoreEmoji(player[picksType]["Diff"], player[picksType]["Points"])}
                                      </span>
                                    </td>
                                    {!isTrader && (
                                      <td key={"Consensus Line"} className={"text-center"}>
                                        {player["Consensus"]}
                                        {/* <div>Points Scored </div> */}
                                      </td>
                                    )}
                                    <td key={"Minutes"} className={"text-center"}>
                                      {player[picksType]?.["Minutes"]}
                                    </td>
                                    {/* <td key={"Matchup Difficulty"} className={"text-center"}>
                                    {player["Matchup Difficulty"]}
                                  </td>
                                  <td key={"Projected Defensive Matchup"} className={"text-center"}>
                                    {player["Projected Defensive Matchup"]}
                                  </td>
                                  <td key={"Matchup Insight"} className={"text-center"}>{player["Matchup Insight"]}</td> */}
                                  </tr>
                                  <tr>
                                    <td colSpan={3} className="pt-0">
                                      {player?.[picksType + "_Sentence"]}
                                    </td>
                                    <td colSpan={10} className="pt-0"></td>
                                  </tr>
                                </Fragment>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                        {/* Cards for mobile view */}
                        <div className="d-md-none">
                          {filteredGameLogs.map((player, index) => (
                            <Card key={"card" + index} className="m-3 rounded-lg">
                              <Card.Body className="rounded-lg">
                                <Card.Title className="mb-0">
                                  <Link
                                    href={`/${leagueName}/player-props/${player["Team"]}/${player.Player}`}
                                    target="_blank"
                                  >
                                    {player.Player}
                                  </Link>
                                </Card.Title>
                                <span className="d-block">{player["date"]}</span>
                                <Card.Text>
                                  <strong>Team: </strong>
                                  <span>
                                    <Link href={`/team/${leagueName}/${year}/${player["Team"]}`} target="_blank">
                                      {player["Team"]}
                                    </Link>
                                  </span>
                                  <br />
                                  <strong>Opponent: </strong>
                                  <span>
                                    <Link
                                      href={`/${leagueName}/matchup-output/${player["Team"]}/${player["Opponent"]}/true`}
                                      target="_blank"
                                    >
                                      <Image
                                        src={`/static/media/logos/${player["Opponent"]}.png`}
                                        alt={player["Opponent"]}
                                        width={24}
                                        height={24}
                                      />{" "}
                                      {player["Opponent"]}
                                    </Link>
                                  </span>
                                  <br />
                                  {!isTrader && (
                                    <>
                                      <strong>Consensus Line: </strong> {player["Consensus"]}
                                      {/* Points Scored */}
                                      <br />
                                    </>
                                  )}
                                </Card.Text>
                                {/* <Card.Text>(O/U)</Card.Text> */}
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Avg Pts Per Game</th>
                                      <th>Avg SQ Points Scored Per Game</th>
                                      <th>Difference</th>
                                      <th>Avg Minutes Per Game</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{player[picksType]["Points"]}</td>
                                      <td>{player[picksType]["SQ Points"]}</td>
                                      <td>{`${Math.abs(player[picksType]["Diff"])} ${getPlayerScoreEmoji(
                                        player[picksType]["Diff"],
                                        player[picksType]["Points"]
                                      )}`}</td>
                                      <td>{player[picksType]?.["Minutes"]}</td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/* <Card.Text>
                                  Matchup Difficulty: {player["Matchup Difficulty"]} <br />
                                  Projected Defensive Matchup:{" "}
                                  {player["Projected Defensive Matchup"]} <br />
                                  Matchup Insight: {player["Matchup Insight"]} <br />
                                </Card.Text> */}
                                <Card.Text>{player?.[picksType + "_Sentence"]}</Card.Text>
                              </Card.Body>
                            </Card>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-12 text-center">
                          <h3>No Data Available</h3>
                        </div>
                      </div>
                    )}

                    <Row style={{ display: "flex", marginTop: "40px" }}>
                      <Col>
                        <section className="accordion-container">
                          <div className="row">
                            <div className="col-md-5">
                              <div className="box col-md-12 titles-container align-items-center justify-content-center">
                                <h3>Player Props Research Tips</h3>
                                <p>
                                  The Player Props Research tool is powered by ShotQuality data. Here's how it works:
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      Compare a player's average points per game vs. their average ShotQuality points
                                      per game. If a player's average points per game is greater than their average SQ
                                      points per game, that implies the player has overpeformed recently. A lower points
                                      per game average means they've been underperforming lately. Check out the
                                      Difference column for some quick insights.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Click on each player's name to check out the Player Pages. Look at recent
                                      gamelogs, data visualizations, player tendencies and shot type breakdowns. Then
                                      leverage all of this data to make your pick!
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-md-7" itemScope itemType="https://schema.org/FAQPage">
                              {accordionData.map(({ name, acceptedAnswer, id, content }) => {
                                return (
                                  <div
                                    key={name}
                                    style={{
                                      boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                                    }}
                                  >
                                    <Accordion title={name} content={content} id={id} />{" "}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </section>
                      </Col>
                    </Row>
                  </>
                </div>
              </section>
              <WinningMetrics targetPage={"PlayerProps"} />
            </div>
          </main>
        ) : (
          <NotFound />
        )}
      </MainLayout>
    </>
  );
};

export default PlayerPropsPage;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
